import { SaleType } from "constants/sale";
import { PricingTypeId } from "constants/pricingTypes";

export interface SaleFormValues {
  date: string;
  sale_title: string;
  sale_sub_type_id: number | null;
  sale_round_id: string | null;
  sale_type: SaleType | null;
  notes: string;
  pricing_type_id: number;
  species_id: number | null;
  deployment_ids: number[];
  deployment_sales: Partial<DeploymentSaleCreate>[];
}

export interface CarrierChargeFormValues {
  carrier: string | null;
  deliveryDate: string | null;
  notes: string | null;
  invoiceNumber: string | null;
  invoiceAmount: number | null;
}

export interface ConsignmentFormValues {
  billing_reference: string | null;
  vendor_id: string | null;
  vendor_property_id: string | null;
  carrierCharge?: CarrierChargeFormValues;
}

export interface SaleLotFormValues {
  // WHO
  buyer_id: string | null;
  destination_property_id: string | null;
  buyer_way: { id: number; name: string } | null;
  consignment_id: string | null;
  // WHAT
  quantity: number | null;
  quantity_progeny: number;
  product_id: string | null;
  sex_id: number | null;
  age_id: number | null;
  breed_id: number | null;
  dentitionId: number | null;
  estimatedAverageMassGrams: number | null;
  marks: Mark[];
  labels: string[];
  draftingAttributes: DraftingAttributes | null;
  exemption_id: number | null;
  estimatedAverageWeightId: number | null;
  dressingRangeId: number | null;
  grade_id: number | null;
  category_id: number | null;
  note: string;
  // PRICE
  pricing_type_id: number | null;
  unit_price: string | null;
  total_mass_grams: number;
  quantity_delivered: number | null;
  reservePrice: number | null;
  invoiceToBusinessId: string | null;
  // EIDs
  quantityTagsUsed: number;
  // MEDIA
  youtube_link: string;
  sale_round_id: number | null;
}

export interface SkinLotFormValues {
  quantity: number | null;
  unitPrice: string | null;
  pricing_type_id: number;
  total_mass_grams: number;
}

export interface TransactionalSaleFormValues {
  sale?: SaleFormValues;
  consignment?: ConsignmentFormValues;
  saleLot: Partial<SaleLotFormValues>;
  skinsLots?: SkinLotFormValues[];
}

export interface SaleLotCreateFormValues
  extends Omit<Partial<SaleLotFormValues>, "total_mass_grams"> {
  unitPrice?: string | null;
  total_mass_grams?: number | string;
}

export interface MobileTransactionalCreateSaleFormValues
  extends TransactionalSaleFormValues {
  sale?: SaleFormValues;
  consignment?: ConsignmentFormValues;
  saleLots?: SaleLotCreateFormValues[];
  skinsLots?: SkinLotFormValues[];
}

export interface MobileTransactionalEditSaleLotFormValues
  extends TransactionalSaleFormValues {
  saleLot: SaleLotFormValues;
}

export const defaultSkinLot: SkinLotFormValues = {
  quantity: null,
  unitPrice: null,
  pricing_type_id: PricingTypeId.PER_HEAD,
  total_mass_grams: 0,
};

export const defaultSaleLot: SaleLotFormValues = {
  buyer_id: null,
  destination_property_id: null,
  buyer_way: null,
  consignment_id: null,
  quantity: null,
  quantity_progeny: 0,
  product_id: null,
  sex_id: null,
  age_id: null,
  breed_id: null,
  dentitionId: null,
  marks: [],
  labels: [],
  draftingAttributes: null,
  exemption_id: null,
  estimatedAverageMassGrams: 0,
  estimatedAverageWeightId: null,
  dressingRangeId: null,
  grade_id: null,
  category_id: null,
  note: "",
  pricing_type_id: 2,
  unit_price: null,
  total_mass_grams: 0,
  quantity_delivered: null,
  reservePrice: null,
  invoiceToBusinessId: null,
  quantityTagsUsed: 0,
  youtube_link: "",
  sale_round_id: null,
};

export const defaultCreateSaleValues: MobileTransactionalCreateSaleFormValues =
  {
    sale: {
      date: "",
      sale_title: "",
      sale_sub_type_id: null,
      sale_round_id: null,
      sale_type: null,
      notes: "",
      pricing_type_id: 2,
      species_id: null,
      deployment_ids: [],
      deployment_sales: [],
    },
    consignment: {
      billing_reference: null,
      vendor_id: null,
      vendor_property_id: null,
      carrierCharge: {
        carrier: null,
        deliveryDate: null,
        notes: null,
        invoiceNumber: null,
        invoiceAmount: null,
      },
    },
    saleLot: {
      buyer_id: null,
    },
    saleLots: [defaultSaleLot],
    skinsLots: [defaultSkinLot],
  };
